class Metric {
    id: number;
    table: number;
    originalName: string;
    metricName: string;
    formulaTop: string;
    formulaBottom: string;
    calculateTotals: CalculateTotalsEnum;
    groupingType: GroupingTypeEnum;

    format: FieldFormatEnum;
    decimalPlaces: number;
    foreColor: string;
    backgroundColor: string;
    thresholdValue: number;
    thresholdColor: string;
    formattingRule: number;
    order: number;
    accountingStyle: boolean;
    visibility: VisibilityEnum;

    get tableName() {
        return null;
    }

    constructor(data: any) {
        this.id = data.id;
        this.table = data.table;
        this.originalName = data.originalName;
        this.metricName = data.metricName;
        this.formulaTop = data.formulaTop;
        this.formulaBottom = data.formulaBottom;
        this.calculateTotals = data.calculateTotals;
        this.groupingType = data.groupingType;

        this.format = data.format ?? FieldFormatEnum.Numeric;
        this.decimalPlaces = data.decimalPlaces ?? 2;
        this.foreColor = data.foreColor;
        this.backgroundColor = data.backgroundColor;
        this.thresholdValue = data.thresholdValue;
        this.thresholdColor = data.thresholdColor;
        this.formattingRule = data.formattingRule;
        this.order = data.order;
        this.accountingStyle = data.accountingStyle ?? false;
        this.visibility = data.visibility ?? VisibilityEnum.Normal;
    }
}